import { OwnerOptionsDTO } from '../../api/useInsuranceQuery';

export const getIsOwnerTrust = (owner: string, ownerOptions: OwnerOptionsDTO) => {
  const trustOptions = ownerOptions.Trusts;

  return !!trustOptions?.find(trust => trust.Name === owner);
};
